export default __webpack_public_path__ + "static/media/Alice.d5b44e4e.jpg";